import { Navigate, useLocation } from 'react-router-dom';

import { useAuthTokenContext } from '@/auth/KeycloakProvider';
import { ROUTES } from '@/config/routes';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { tokenStatus } = useAuthTokenContext();
  const location = useLocation();

  // Show loading state while checking auth
  if (tokenStatus === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  // Redirect to auth if not authenticated
  if (tokenStatus === 'invalid') {
    return <Navigate to={ROUTES.AUTH} state={{ from: location }} replace />;
  }

  // Render protected content
  return <>{children}</>;
};
